import {
  Button,
  ScrollableDialogContent,
  CloseDialogButton,
  DialogFooter,
} from '@cast/design-system';

import { StepContainer } from './StepLayout';
import { ErrorState } from '../ErrorState';

type ErrorStepProps = {
  title: string;
  testId?: string;
  onRetry: () => void;
  onClose: () => void;
};

export const ErrorStep = ({
  title,
  testId,
  onRetry,
  onClose,
}: ErrorStepProps) => {
  return (
    <StepContainer position="relative" data-testid={testId}>
      <CloseDialogButton onClose={onClose} />

      <ScrollableDialogContent sx={{ p: 24 }}>
        <ErrorState
          title={title}
          testId={testId ? `${testId}-state` : undefined}
        />
      </ScrollableDialogContent>
      <DialogFooter
        start={
          <Button variant="secondary" onClick={onClose} testId="close-button">
            Close
          </Button>
        }
        end={
          <Button onClick={onRetry} testId="retry-button">
            Retry
          </Button>
        }
      />
    </StepContainer>
  );
};
